import React, { FC, HTMLAttributes } from 'react'
import classNames from 'classnames'
import 'assets/scss/5_components/_display-tile.scss'

export const DisplayTile: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  const classes = classNames('display-tile', className)
  return <div className={classes}>{children}</div>
}

export const DisplayTileHeader: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  const classes = classNames('display-tile-header', className)
  return <div className={classes}>{children}</div>
}

export const DisplayTileHeaderAction: FC<HTMLAttributes<HTMLSpanElement>> = ({
  children,
  className,
}) => {
  const classes = classNames('display-tile-header-action', className)
  return <span className={classes}>{children}</span>
}

export const DisplayTileSection: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  const classes = classNames('display-tile-section', className)
  return <div className={classes}>{children}</div>
}
